import React, { useEffect } from 'react';
import * as S from './Modal.styled';

interface ModalProps {
  isOpen: boolean;
  maxWidth?: number;
  borderRadius?: number;
  onClose?: () => void;
  isScrollLocked?: boolean;
  dataTestId?: string;
  className?: string;
  children: React.ReactNode;
}

export const Modal = ({
  isOpen,
  onClose,
  children,
  maxWidth = 460,
  borderRadius = 14,
  dataTestId,
  isScrollLocked = false,
  className,
}: ModalProps) => {
  useEffect(() => {
    if (isScrollLocked) {
      document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    }
  }, [isOpen, isScrollLocked]);

  if (!isOpen) return null;

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onClose?.();
  };

  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <S.ModalWrapper data-testid={dataTestId}>
      <S.Backdrop
        onClick={handleClose}
        $isOpen={isOpen}
        data-testid="modal-backdrop"
        className="reveal-modal-bg"
      />
      <S.ModalContent
        $isOpen={isOpen}
        $maxWidth={maxWidth}
        className={className}
        $borderRadius={borderRadius}
        onClick={handleContentClick}
        data-testid="modal-content"
      >
        {children}
      </S.ModalContent>
    </S.ModalWrapper>
  );
};
